import { useState } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaGithub, FaLinkedin } from "react-icons/fa";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
import classNames from "classnames";

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function ContactMe() {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [status, setStatus] = useState(null);

  const onSubmit = async ({ name, email, message, website }) => {
    // Honeypot: los bots rellenan el campo oculto, las personas no.
    if (website) {
      setStatus("ok");
      reset();
      return;
    }

    setStatus(null);

    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        { name, email, message },
        { publicKey: PUBLIC_KEY }
      );
      setStatus("ok");
      reset();
    } catch (error) {
      console.error("EmailJS:", error);
      setStatus("error");
    }
  };

  const inputClass = (error) =>
    classNames("pf-form__input", { "is-invalid": error });

  return (
    <section id="contacto" className="pf-section" style={{ backgroundColor: "var(--bg)" }}>
      <div className="container">
        <p className="pf-section__label">Hablemos</p>
        <h2 className="pf-section__title">Contáctame</h2>
        <div className="pf-section__divider" />

        <div className="row g-5">

          {/* Info */}
          <div className="col-lg-4">
            <div className="pf-contact__info-card">
              <FaEnvelope size={20} className="pf-contact__info-icon" />
              <div>
                <p className="pf-contact__info-label mb-0">Email</p>
                <a href="mailto:ricardo991120@gmail.com" className="pf-contact__info-value">
                  ricardo991120@gmail.com
                </a>
              </div>
            </div>

            <div className="pf-contact__info-card">
              <FaMapMarkerAlt size={20} className="pf-contact__info-icon" />
              <div>
                <p className="pf-contact__info-label mb-0">Ubicación</p>
                <span className="pf-contact__info-value">México, Querétaro</span>
              </div>
            </div>

            <div className="pf-contact__socials">
              <a href="https://github.com/Swankestriver" target="_blank" rel="noopener noreferrer" className="pf-contact__social" title="GitHub">
                <FaGithub size={18} />
              </a>
              <a href="https://www.linkedin.com/in/ricardo-lopez-ortiz-9b5625240/" target="_blank" rel="noopener noreferrer" className="pf-contact__social" title="LinkedIn">
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Formulario */}
          <div className="col-lg-8">
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row g-3">
                <div className="col-sm-6">
                  <input
                    type="text"
                    placeholder="Nombre"
                    aria-label="Nombre"
                    aria-invalid={errors.name ? "true" : "false"}
                    className={inputClass(errors.name)}
                    {...register("name", { required: "El nombre es requerido." })}
                  />
                  {errors.name && <p className="pf-form__error">{errors.name.message}</p>}
                </div>

                <div className="col-sm-6">
                  <input
                    type="email"
                    placeholder="Email"
                    aria-label="Email"
                    aria-invalid={errors.email ? "true" : "false"}
                    className={inputClass(errors.email)}
                    {...register("email", {
                      required: "El email es requerido.",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Ingresa un email válido.",
                      },
                    })}
                  />
                  {errors.email && <p className="pf-form__error">{errors.email.message}</p>}
                </div>

                <div className="col-12">
                  <textarea
                    rows={6}
                    placeholder="Mensaje"
                    aria-label="Mensaje"
                    aria-invalid={errors.message ? "true" : "false"}
                    className={inputClass(errors.message)}
                    style={{ resize: "vertical" }}
                    {...register("message", { required: "El mensaje es requerido." })}
                  />
                  {errors.message && <p className="pf-form__error">{errors.message.message}</p>}
                </div>

                {/* Honeypot anti-spam: invisible para el usuario, no para los bots. */}
                <div className="pf-form__honeypot" aria-hidden="true">
                  <input
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    placeholder="No llenar este campo"
                    {...register("website")}
                  />
                </div>

                <div className="col-12">
                  <button
                    type="submit"
                    className="btn-pf-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Enviando..." : "Enviar mensaje"}
                  </button>

                  {status === "ok" && (
                    <p className="pf-form__status pf-form__status--ok" role="status">
                      ¡Mensaje enviado! Te responderé pronto.
                    </p>
                  )}
                  {status === "error" && (
                    <p className="pf-form__status pf-form__status--error" role="alert">
                      No se pudo enviar. Escríbeme directo a{" "}
                      <a href="mailto:ricardo991120@gmail.com">ricardo991120@gmail.com</a>.
                    </p>
                  )}
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}
